import { MinorNightWorkRule } from 'constants/MinorNightWorkRule';
import {
  CONTRACT_COMPLIANCE__RULE_16_17,
  CONTRACT_COMPLIANCE__RULE_16_17_NOTE,
  CONTRACT_COMPLIANCE__RULE_ABSOLUTE_PROHIBITION,
  CONTRACT_COMPLIANCE__RULE_ABSOLUTE_PROHIBITION_NOTE,
  CONTRACT_COMPLIANCE__RULE_UNDER_16,
  CONTRACT_COMPLIANCE__RULE_UNDER_16_NOTE,
} from 'translations/constants';

export const RULES: MinorNightWorkRule[] = [
  MinorNightWorkRule.ABSOLUTE_PROHIBITION,
  MinorNightWorkRule.UNDER_16,
  MinorNightWorkRule.AGE_16_17,
];

export const RULE_TITLE_KEYS: Record<MinorNightWorkRule, string> = {
  [MinorNightWorkRule.ABSOLUTE_PROHIBITION]: CONTRACT_COMPLIANCE__RULE_ABSOLUTE_PROHIBITION,
  [MinorNightWorkRule.UNDER_16]: CONTRACT_COMPLIANCE__RULE_UNDER_16,
  [MinorNightWorkRule.AGE_16_17]: CONTRACT_COMPLIANCE__RULE_16_17,
};

export const RULE_NOTE_KEYS: Record<MinorNightWorkRule, string> = {
  [MinorNightWorkRule.ABSOLUTE_PROHIBITION]: CONTRACT_COMPLIANCE__RULE_ABSOLUTE_PROHIBITION_NOTE,
  [MinorNightWorkRule.UNDER_16]: CONTRACT_COMPLIANCE__RULE_UNDER_16_NOTE,
  [MinorNightWorkRule.AGE_16_17]: CONTRACT_COMPLIANCE__RULE_16_17_NOTE,
};

export const RULE_SLUGS: Record<MinorNightWorkRule, string> = {
  [MinorNightWorkRule.ABSOLUTE_PROHIBITION]: 'absolute-prohibition',
  [MinorNightWorkRule.UNDER_16]: 'under-16',
  [MinorNightWorkRule.AGE_16_17]: '16-17',
};

export const MAX_MINOR_AGE_YEARS = 17;

export const hasAgeBand = (rule: MinorNightWorkRule): boolean => rule !== MinorNightWorkRule.ABSOLUTE_PROHIBITION;
